import { create } from 'zustand';

const useUserStore = create(( set, get ) => ({
  userId: null,
  email: '',
  phone: '',
  fullName: '',
  terms: false,
  token: '',
  setUserInfo: (userInfo) => set(userInfo),
  getToken: () => get().token || sessionStorage.getItem('token'),
  resetToken: () => {
    sessionStorage.removeItem('token');
    set({token: ''})
  },
}));

export default useUserStore;
